import React from "react";

export interface TwoColumnLayoutProps {
  /** The content to render in the aside column */
  aside: React.ReactNode;
  /** The main content */
  children: React.ReactNode;
  /** CSS width for the aside column (e.g., "clamp(300px, 15vw, 10%)" or "25%") */
  asideWidth?: string;
  /** Top offset for sticky behavior (e.g., "100px") */
  stickyTop?: string;
  /** Padding inside each column */
  paddingClass?: string;
  /** Additional class names for the aside container */
  asideClassName?: string;
  /** Additional class names for the main container */
  mainClassName?: string;
}

const TwoColumnLayout: React.FC<TwoColumnLayoutProps> = ({
  aside,
  children,
  asideWidth = "clamp(300px, 15vw, 10%)",
  stickyTop = "100px",
  paddingClass = "p-4",
  asideClassName = "space-y-4 text-white",
  mainClassName = "flex-1 p-8",
}) => {
  // Calculate the height for the aside: full viewport minus stickyTop
  const asideHeightCalc = `calc(100vh - ${stickyTop})`;

  return (
    <div className="flex flex-row w-full">
      <aside
        className={`${paddingClass} ${asideClassName} sticky overflow-y-auto`}
        style={{
          width: asideWidth,
          top: stickyTop,
          height: asideHeightCalc,
        }}
      >
        {aside}
      </aside>
      <main
        className={mainClassName}
        style={{ width: `calc(100vw - ${asideWidth})` }}
      >
        {children}
      </main>
    </div>
  );
};

export default TwoColumnLayout;
